export default __webpack_public_path__ + "static/media/leg-icon-medical.0dadbb90.png";